import { apiClient } from '@/lib/apiClient';

/** Status: extracted | empty | not_clinical | readonly | not_found. */
export interface ClinicalResolution {
  status: string;
  fieldsJson: string;
}

/**
 * Ask the backend to turn a clinical command on the open consultation ("mark tooth 26 as caries")
 * into the same structured edits the dictation flow produces. Read-only — the actual writes happen
 * on confirm via the existing chart/notes endpoints. Only the command text reaches the model.
 */
export const resolveClinicalCommand = async (consultationId: string, command: string): Promise<ClinicalResolution> => {
  const { data } = await apiClient.post<ClinicalResolution>('/ai/clinical/resolve', { consultationId, command });
  return data;
};
